import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { useAuthenticatedImage } from "@/hooks/useAuthenticatedImage";

interface AvatarWithFallbackProps {
  image?: string;
  emptyImageText?: string;
  className?: string;
  imageClassName?: string;
  folder?: string;
}

export const AvatarWithFallback: React.FC<AvatarWithFallbackProps> = ({
  image,
  emptyImageText,
  className = "",
  imageClassName = "",
  folder = 'avatars',
}) => {
  const { imageUrl } = useAuthenticatedImage(image, folder);

  return imageUrl || emptyImageText ? (
    <Avatar className={`h-9 w-9 !outline-none ${className}`}>
      {imageUrl ? (
        <AvatarImage
          src={imageUrl}
          alt={emptyImageText || ""}
          className={`!outline-none ${
            !imageUrl
              ? "bg-[linear-gradient(180deg,#EBEBEB_0%,#DED9D9_100%)] text-zinc-950 p-1"
              : ""
          } ${imageClassName}`}
        />
      ) : (
        <AvatarFallback
          className={`!outline-none ${
            !imageUrl
              ? "bg-[linear-gradient(180deg,#EBEBEB_0%,#DED9D9_100%)] text-zinc-950 p-1"
              : ""
          } ${imageClassName}`}
        >
          {emptyImageText}
        </AvatarFallback>
      )}
    </Avatar>
  ) : null;
};
